import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IDonHangViewChiTietActionPayload<T> {
    donHangId: number,
    data: T
}
export const eDonHangViewChiTietActionsDefine = {
    INIT_DONHANG:0,
    GET_HTML_PRINT_START: 0,
    GET_HTML_PRINT_SUCCESS: {} as IDonHangViewChiTietActionPayload<string>,
    GET_HTML_PRINT_ERROR: {} as IDonHangViewChiTietActionPayload<string>,
};
export const eDonHangViewChiTietActionIds = generateActionTypeIds(eDonHangViewChiTietActionsDefine, "DON_HANG_VIEW_CHI_TIET");
export type IDonHangViewChiTietActionTypes = IGenericActionType<typeof eDonHangViewChiTietActionsDefine, "DON_HANG_VIEW_CHI_TIET">;
